export default __webpack_public_path__ + "static/media/chatLogo.1d7e3625.png";